import { CheckCircle, Clock, AlertTriangle, MapPin } from 'lucide-react';

interface ReportsTableProps {
  filters: any;
}

const ReportsTable = ({ filters }: ReportsTableProps) => {
  // Mock data
  const reports = [
    { id: 'RPT-001', description: 'No water supply for 3 days', ward: 'Biashara', category: 'Water', status: 'Pending', urgency: 9, date: '2024-01-15' },
    { id: 'RPT-002', description: 'Road full of potholes causing accidents', ward: 'Kaptembwo', category: 'Roads', status: 'In Progress', urgency: 7, date: '2024-01-14' },
    { id: 'RPT-003', description: 'Flooding in residential area', ward: 'Naivasha East', category: 'Flooding', status: 'Urgent', urgency: 10, date: '2024-01-13' },
    { id: 'RPT-004', description: 'Garbage not collected for 2 weeks', ward: 'London', category: 'Garbage', status: 'Resolved', urgency: 5, date: '2024-01-12' },
    { id: 'RPT-005', description: 'Power outage for 48 hours', ward: 'Kapkures', category: 'Electricity', status: 'Pending', urgency: 8, date: '2024-01-11' },
  ];

  const getStatusIcon = (status: string) => {
    switch (status.toLowerCase()) {
      case 'resolved': return <CheckCircle className="text-green-500" size={16} />;
      case 'in progress': return <Clock className="text-yellow-500" size={16} />;
      case 'urgent': return <AlertTriangle className="text-red-500" size={16} />;
      default: return <Clock className="text-gray-500" size={16} />;
    }
  };

  const getUrgencyColor = (urgency: number) => {
    if (urgency >= 9) return 'bg-red-500';
    if (urgency >= 7) return 'bg-orange-500';
    if (urgency >= 5) return 'bg-yellow-500';
    return 'bg-green-500';
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ward</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Urgency</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {reports.map((report) => (
            <tr key={report.id} className="hover:bg-gray-50">
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="text-sm font-medium text-gray-900">{report.id}</span>
              </td>
              <td className="px-6 py-4">
                <div className="text-sm text-gray-900">{report.description}</div>
                <div className="text-xs text-gray-500">{report.date}</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <MapPin size={14} className="text-gray-400 mr-2" />
                  <span className="text-sm text-gray-900">{report.ward}</span>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                  {report.category}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  {getStatusIcon(report.status)}
                  <span className="ml-2 text-sm text-gray-900 capitalize">{report.status}</span>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div className={`w-16 h-2 rounded-full ${getUrgencyColor(report.urgency)} mr-3`}></div>
                  <span className="text-sm font-medium">{report.urgency}/10</span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReportsTable;